import type { FormEvent } from 'react';
import SocialButtons from './SocialButtons';

interface Props {
  email: string;
  password: string;
  loading: boolean;
  onEmailChange: (value: string) => void;
  onPasswordChange: (value: string) => void;
  onSubmit: (e: FormEvent) => void;
  onSwitchView: (view: 'signup' | 'forgot') => void;
}

export default function LoginForm({
  email,
  password,
  loading,
  onEmailChange,
  onPasswordChange,
  onSubmit,
  onSwitchView,
}: Props) {
  return (
    <div className="auth-form">
      <div>
        <h2>Welcome back</h2>
        <p className="auth-subtitle">Sign in to your account</p>
      </div>
      <SocialButtons />
      <div className="auth-divider">
        <span>or</span>
      </div>
      <form onSubmit={onSubmit} className="auth-form">
        <div className="field">
          <label className="field-label" htmlFor="email">
            Email
          </label>
          <input
            id="email"
            className="input"
            type="email"
            value={email}
            onChange={(e) => onEmailChange(e.target.value)}
            required
            autoComplete="email"
            placeholder="you@company.com"
          />
        </div>
        <div className="field">
          <label className="field-label" htmlFor="password">
            Password
          </label>
          <input
            id="password"
            className="input"
            type="password"
            value={password}
            onChange={(e) => onPasswordChange(e.target.value)}
            required
            autoComplete="current-password"
            placeholder="Enter your password"
          />
        </div>
        <button type="submit" className="btn btn-primary" disabled={loading}>
          {loading ? 'Signing in...' : 'Sign In'}
        </button>
        <div className="auth-links">
          <button type="button" className="link-btn" onClick={() => onSwitchView('signup')}>
            Create account
          </button>
          <button type="button" className="link-btn" onClick={() => onSwitchView('forgot')}>
            Forgot password?
          </button>
        </div>
      </form>
    </div>
  );
}
